import { yodaAgentConstants } from "../constants";
import { yodaAgentService } from "../services";
import { yodaUtilsActions } from "./yodaUtils.actions";

export const yodaAgentActions = {
  getAll,
  getOne,
};

function getAll() {
  return (dispatch) => {
    dispatch(request());

    yodaAgentService.getAll().then(
      (response) => {
        if (response.results != null) {
          const { results } = response;
          dispatch(success(results));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaAgentConstants.GETAGENT_ALL_REQUEST };
  }
  function success(agents) {
    return {
      type: yodaAgentConstants.GETAGENT_ALL_SUCCESS,
      payload: { agents },
    };
  }
  function failure(error) {
    return {
      type: yodaAgentConstants.GETAGENT_ALL_FAILURE,
      payload: { error },
    };
  }
}

function getOne(agentId) {
  const callback = (dispatch) => {
    dispatch(request());
    yodaAgentService.getOne(agentId).then(
      (response) => {
        if (response != null) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaAgentService.getOne",
      { agentId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaAgentConstants.GETAGENT_ONE_REQUEST };
  }
  function success(agent) {
    return {
      type: yodaAgentConstants.GETAGENT_ONE_SUCCESS,
      payload: { agent },
    };
  }
  function failure(error) {
    return {
      type: yodaAgentConstants.GETAGENT_ONE_FAILURE,
      payload: { error },
    };
  }
}
